'use client';

import cx from 'classnames';
import { DetailedHTMLProps, HTMLAttributes, useEffect, useState } from 'react';
import AuthorsTabLink from '../atoms/authors-tab-link';
import { useAppState } from '../providers/state-provider';

export default function AuthorsTabs({
  className,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) {
  const {
    state: { searchParams },
  } = useAppState();

  const [tab, setTab] = useState('Sermon Prep');

  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries());

    if (
      params.type === 'Illustrations · Quotes · Humor' &&
      (!params.tab || params.tab === 'Illustrations')
    ) {
      setTab('Illustrations');
    } else if (
      params.type === 'Illustrations · Quotes · Humor' &&
      params.tab === 'Quotes'
    ) {
      setTab('Quotes');
    } else if (params.type === "Children's Sermons") {
      setTab("Children's Sermons");
    } else {
      setTab('Sermon Prep');
    }
  }, [searchParams]);

  return (
    <nav
      className={cx(
        'w-full overflow-auto bg-sermons-dark text-white font-bold h-10',
        className,
      )}
      {...props}
    >
      <div className='grid min-w-[672px] grid-cols-5 whitespace-nowrap'>
        <div
          className={cx(
            'flex h-10 items-center justify-center border-b-4 cursor-pointer',
            {
              'border-b-sermons-highlight': tab === 'Sermon Prep',
              'border-b-sermons-dark': tab !== 'Sermon Prep',
            },
          )}
        >
          <AuthorsTabLink
            tab='Sermon Prep'
            linkText='Sermons'
            setTab={setTab}
            paramSetup={(isSearch, searchParams) => {
              if (isSearch) {
                searchParams.set('type', 'Sermon Prep');
                searchParams.delete('tab');
              } else {
                searchParams.set('tab', 'Sermon Prep');
              }
              return searchParams;
            }}
          />
        </div>
        <div
          className={cx(
            'flex h-10 items-center justify-center border-b-4 cursor-pointer',
            {
              'border-b-sermons-highlight': tab === 'Illustrations',
              'border-b-sermons-dark': tab !== 'Illustrations',
            },
          )}
        >
          <AuthorsTabLink
            tab='Illustrations'
            linkText='Illustrations'
            setTab={setTab}
            paramSetup={(isSearch, searchParams) => {
              if (isSearch) {
                searchParams.set('type', 'Illustrations · Quotes · Humor');
                searchParams.delete('tab');
              } else {
                searchParams.set('tab', 'Illustrations');
              }
              return searchParams;
            }}
          />
        </div>
        <div
          className={cx(
            'flex h-10 items-center justify-center border-b-4 cursor-pointer',
            {
              'border-b-sermons-highlight': tab === 'Quotes',
              'border-b-sermons-dark': tab !== 'Quotes',
            },
          )}
        >
          <AuthorsTabLink
            tab='Quotes'
            linkText='Quotes'
            setTab={setTab}
            paramSetup={(isSearch, searchParams) => {
              if (isSearch) {
                searchParams.set('type', 'Illustrations · Quotes · Humor');
                searchParams.set('tab', 'Quotes');
              } else {
                searchParams.set('tab', 'Quotes');
              }
              return searchParams;
            }}
          />
        </div>
        <div
          className={cx(
            'flex h-10 items-center justify-center border-b-4 cursor-pointer',
            {
              'border-b-sermons-highlight': tab === "Children's Sermons",
              'border-b-sermons-dark': tab !== "Children's Sermons",
            },
          )}
        >
          <AuthorsTabLink
            tab={"Children's Sermons"}
            linkText={"Children's Sermons"}
            setTab={setTab}
            paramSetup={(isSearch, searchParams) => {
              if (isSearch) {
                searchParams.set('type', "Children's Sermons");
                searchParams.delete('tab');
              } else {
                searchParams.set('tab', "Children's Sermons");
              }
              return searchParams;
            }}
          />
        </div>
      </div>
    </nav>
  );
}
